"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports.deleteFilter = deleteFilter;
exports.endpoints = void 0;
exports.execute = execute;
exports.list = list;
exports.update = update;
exports.updateCategoryRules = updateCategoryRules;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _requests = require("@edison/requests");
var _functools = require("@edison/functools");
var _utils = require("./utils");
var _constants = require("../utils/constants");
var endpoints = exports.endpoints = {
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/filter/all");
    }
  },
  create: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/filter");
    }
  },
  "delete": {
    method: 'DELETE',
    url: function url(filterId) {
      return "/".concat(_constants.API_V1, "/filter/").concat(filterId);
    }
  },
  update: {
    method: 'PUT',
    url: function url(filterId) {
      return "/".concat(_constants.API_V1, "/filter/").concat(filterId);
    }
  },
  execute: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/filter/action");
    }
  },
  category: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/filter/category");
    }
  }
};
/**
 * Return a filter of folders
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<FilterListResponse>}
 * @throws {RequestError}
 */
function list(_x) {
  return _list.apply(this, arguments);
}
function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, optionals, _endpoints$list, method, url;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          auth = _ref.auth;
          optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
          _context.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}
/**
 * Create a new filter
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {Filter} filterObject - filter object
 * @returns {Promise<FilterCreateResponse>}
 */
function create(_x2, _x3) {
  return _create.apply(this, arguments);
}
function _create() {
  _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(filter, _ref2) {
    var auth, optionals, _endpoints$create, method, url, res;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          auth = _ref2.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(filter))(_utils.defaultOptionals);
          _endpoints$create = endpoints.create, method = _endpoints$create.method, url = _endpoints$create.url;
          _context2.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _create.apply(this, arguments);
}
/**
 * delete a filter
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {FilterId} filterId - filter object
 * @returns {Promise<FilterDeleteResponse>}
 */
function deleteFilter(_x4, _x5) {
  return _deleteFilter.apply(this, arguments);
}
function _deleteFilter() {
  _deleteFilter = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(filterId, _ref3) {
    var auth, optionals, _endpoints$delete, method, url, res;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          auth = _ref3.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$delete = endpoints["delete"], method = _endpoints$delete.method, url = _endpoints$delete.url;
          _context3.next = 5;
          return (0, _requests.request)(url(filterId), method, optionals);
        case 5:
          res = _context3.sent;
          return _context3.abrupt("return", res);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _deleteFilter.apply(this, arguments);
}
/**
 * update a filter
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {FilterId} filterId - filter object
 * @returns {Promise<FilterUpdateResponse>}
 */
function update(_x6, _x7, _x8) {
  return _update.apply(this, arguments);
}
function _update() {
  _update = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(filterId, filter, _ref4) {
    var auth, optionals, _endpoints$update, method, url, res;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          auth = _ref4.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(filter))(_utils.defaultOptionals);
          _endpoints$update = endpoints.update, method = _endpoints$update.method, url = _endpoints$update.url;
          _context4.next = 5;
          return (0, _requests.request)(url(filterId), method, optionals);
        case 5:
          res = _context4.sent;
          return _context4.abrupt("return", res);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _update.apply(this, arguments);
}
function execute(_x9, _x10) {
  return _execute.apply(this, arguments);
}
/**
 * Create/Update/Delete the category related filters based the source and target label
 *
 * @public
 * @param {string} source - DnD source label ID
 * @param {string} target - DnD target label ID
 * @param {string[]} senders - Related sender emails
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<APIResponse<void>>}
 */
function _execute() {
  _execute = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(filter, _ref5) {
    var auth, optionals, _endpoints$execute, method, url, res;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          auth = _ref5.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(filter))(_utils.defaultOptionals);
          _endpoints$execute = endpoints.execute, method = _endpoints$execute.method, url = _endpoints$execute.url;
          _context5.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context5.sent;
          return _context5.abrupt("return", res);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _execute.apply(this, arguments);
}
function updateCategoryRules(_x11, _x12) {
  return _updateCategoryRules.apply(this, arguments);
}
function _updateCategoryRules() {
  _updateCategoryRules = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref6, _ref7) {
    var source, target, senders, auth, optionals, _endpoints$category, method, url, res;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          source = _ref6.source, target = _ref6.target, senders = _ref6.senders;
          auth = _ref7.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            source: source,
            target: target,
            senders: senders
          }))(_utils.defaultOptionals);
          _endpoints$category = endpoints.category, method = _endpoints$category.method, url = _endpoints$category.url;
          _context6.next = 6;
          return (0, _requests.request)(url(), method, optionals);
        case 6:
          res = _context6.sent;
          return _context6.abrupt("return", res);
        case 8:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _updateCategoryRules.apply(this, arguments);
}
//# sourceMappingURL=filters.js.map